import PropTypes from 'prop-types';
import React, { Component } from 'react';
import cx from 'classnames';
import styles from './styles';

class StyledSelect extends Component {
  static propTypes = {
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    required: PropTypes.bool,
    error: PropTypes.string,
    label: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
    })),
    className: PropTypes.string,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    disabled: PropTypes.bool,
  }

  constructor(props) {
    super(props);

    this.getPlaceHolder = this.getPlaceHolder.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  onChange(event) {
    this.props.onChange(event.target.value);
  }

  getPlaceHolder(options) {
    if (!this.props.placeholder) {
      return options;
    }

    const placeholderArray = [
      { value: '', label: this.props.placeholder },
    ];
    placeholderArray.push(...options);
    return placeholderArray;
  }

  render() {
    const {
      label = '',
      options,
      error,
      ...otherProps
    } = this.props;
    const requiredText = this.props.required ? ' *' : '';
    const optionVals = this.getPlaceHolder(options);
    const errorText = error || '';

    const optionTags = optionVals.map(option =>
      <option key={option.value} className={styles.optionText} value={option.value}>
        {option.label}
      </option>,
    );

    const classNames = cx(
      { [styles.dropDownWrapper]: true,
        [this.props.className]: this.props.className },
    );

    const labelClassNames = cx(
      { [styles.dropDownLabel]: true,
        [styles.errorText]: errorText },
    );

    const dropDownClassNames = cx(
      { [styles.prettyDropDown]: true,
        [styles.errored]: errorText,
        [styles.empty]: !this.props.value },
    );

    const errorMessageClassNames = cx(
      { [styles.errorText]: errorText,
        [styles.errorMessage]: errorText },
    );

    return (
      <div className={classNames}>
        <label htmlFor="select" className={labelClassNames}>{label}{requiredText}</label>
        <select
          {...otherProps}
          className={dropDownClassNames}
          onChange={this.onChange}
          value={this.props.value}
        >
          {optionTags}
        </select>
        <div className={errorMessageClassNames}>
          <p className={styles.errorText}>{errorText}</p>
        </div>
      </div>
    );
  }
}

export default StyledSelect;



// WEBPACK FOOTER //
// ./client/app/shared/components/StyledSelect/index.jsx